import ImportRosterMainPage from "../../Components/Import-Roster/ImportRosterMainPage";

const ImportRosterPage = () => {
  return <ImportRosterMainPage />;
};

export default ImportRosterPage;
